module.exports = __webpack_public_path__ + "static/johnnymetrics-logo-green_192px.3d60553b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/johnnymetrics-logo-green_192px.png
// module id = 467
// module chunks = 35783957827783